import React, { useId } from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import { Button } from '../Button';
import { DiscountBlock } from '../DiscountBlock';
import { SubscriptionCardV4 } from '../SubscriptionCardV4';
import { LettersBonusPlans } from '../LettersBonusPlans';
import { PaymentInformationBlock } from '../PaymentInformationBlock';
import { CancelAnytimeBlock } from '../CancelAnytimeBlock';
import styles from './SubscriptionPlanSelectorV4.css';

const cx = classnames.bind(styles);

function SubscriptionPlanSelectorV4({ className = '', plans, onSubmit, selectedSubscriptionData, selectSubscription, isPending = false, expiryTimestamp, onExpirePromo, isExpired, hasPaymentInformation = true, discountTitle, hasDiscountTimer, isLettersBonusOn, onLettersBonusChange }) {
    const classes = cx({
        root: true,
        [className]: Boolean(className)
    });
    const radioGroupName = useId();

    return (
        <div className={classes}>
            <DiscountBlock
                expiryTimestamp={expiryTimestamp}
                onExpirePromo={onExpirePromo}
                isExpired={isExpired}
                title={discountTitle}
                hasTimer={hasDiscountTimer}
            />
            <div className={styles.plans}>
                <LettersBonusPlans
                    plans={plans}
                    selectedSubscriptionData={selectedSubscriptionData}
                    isBonusOn={isLettersBonusOn}
                    onBonusChange={onLettersBonusChange}
                    renderCard={(plan, cardClassName) => (
                        <SubscriptionCardV4
                            className={cardClassName}
                            subscriptionData={plan}
                            selectedSubscriptionData={selectedSubscriptionData}
                            selectSubscription={selectSubscription}
                            isExpired={isExpired}
                            name={radioGroupName}
                            key={plan.plan}
                        />
                    )}
                />
            </div>
            <Button
                type='pine'
                label='Get my plan'
                onClick={() => onSubmit(selectedSubscriptionData)}
                className={cx('button', 'animation')}
                isLoading={isPending}
            />
            <CancelAnytimeBlock />
            {hasPaymentInformation && <PaymentInformationBlock label='pay securely' />}
        </div>
    );
}

SubscriptionPlanSelectorV4.propTypes = {
    className: PropTypes.string,
    plans: PropTypes.array.isRequired,
    onSubmit: PropTypes.func.isRequired,
    selectedSubscriptionData: PropTypes.object.isRequired,
    selectSubscription: PropTypes.func.isRequired,
    isPending: PropTypes.bool,
    expiryTimestamp: PropTypes.any,
    onExpirePromo: PropTypes.func,
    isExpired: PropTypes.bool,
    hasPaymentInformation: PropTypes.bool,
    discountTitle: PropTypes.string,
    hasDiscountTimer: PropTypes.bool,
    isLettersBonusOn: PropTypes.bool.isRequired,
    onLettersBonusChange: PropTypes.func.isRequired
};

export {
    SubscriptionPlanSelectorV4
};
